export default function getModuleProps(
  page: { [key: string]: unknown },
  prefix: string,
): unknown {
  const props: { [key: string]: unknown } = {};

  Object.keys(page).forEach(key => {
    if (key.startsWith(prefix)) {
      const propName =
        key[prefix.length].toLocaleLowerCase() + key.substr(prefix.length + 1);

      props[propName] = page[key];
    }
  });

  return props;
}
